import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { api } from '../utils/api';

const CategoryPage = ({ selectedCity }) => {
  const { categoryId } = useParams();
  const [firms, setFirms] = useState([]);
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const [firmsData, categoriesData] = await Promise.all([
          api.getFirmsByCategory(categoryId, selectedCity),
          api.getCategories()
        ]);
        setFirms(firmsData);
        setCategory(categoriesData.find(c => c.id === categoryId));
      } catch (error) {
        console.error('Error loading category data:', error);
      }
      setLoading(false);
    };
    loadData();
  }, [categoryId, selectedCity]);

  const headerStyle = {
    background: 'linear-gradient(135deg, var(--navy-blue) 0%, var(--baby-blue) 100%)',
    color: 'var(--white)',
    padding: '60px 0',
    textAlign: 'center'
  };

  const firmCardStyle = {
    background: 'var(--white)',
    borderRadius: '12px',
    padding: '24px',
    boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    border: '2px solid transparent'
  };

  const firmGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
    gap: '24px',
    marginTop: '40px'
  };

  const ratingStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '12px'
  };

  const tagStyle = {
    display: 'inline-block',
    background: 'var(--light-blue)',
    color: 'var(--navy-blue)',
    padding: '4px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '500',
    margin: '4px 4px 4px 0'
  };

  if (loading) {
    return (
      <div className="container" style={{ padding: '60px 20px', textAlign: 'center' }}>
        <div style={{ fontSize: '18px', color: 'var(--gray-600)' }}>Yükleniyor...</div>
      </div>
    );
  }

  return (
    <div>
      {/* Header */}
      <section style={headerStyle}>
        <div className="container">
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>
            {category?.icon}
          </div>
          <h1 style={{ fontSize: '36px', marginBottom: '16px', fontFamily: 'Comfortaa, cursive' }}>
            {category?.name}
          </h1>
          <p style={{ fontSize: '18px', opacity: 0.9 }}>
            {selectedCity ? `${selectedCity} şehrindeki ` : ''}
            {category?.name.toLowerCase()} kategorisindeki firmalar
          </p>
          {firms.length > 0 && (
            <p style={{ fontSize: '16px', marginTop: '12px', opacity: 0.8 }}>
              {firms.length} firma bulundu
            </p>
          )}
        </div>
      </section>

      <div className="container" style={{ padding: '60px 20px' }}>
        {firms.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <div style={{ fontSize: '48px', marginBottom: '24px' }}>🔍</div>
            <h2 style={{ fontSize: '24px', marginBottom: '16px', color: 'var(--navy-blue)' }}>
              Firma Bulunamadı
            </h2>
            <p style={{ fontSize: '16px', color: 'var(--gray-600)', marginBottom: '24px' }}>
              {selectedCity ? `${selectedCity} şehrinde ` : ''}
              bu kategoride henüz firma bulunmuyor.
            </p>
            <Link to="/firma-ekle" className="btn btn-primary">
              İlk Firmayı Siz Ekleyin
            </Link>
          </div>
        ) : (
          <div style={firmGridStyle}>
            {firms.map(firm => (
              <div 
                key={firm.id}
                style={firmCardStyle}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.borderColor = 'var(--baby-blue)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.borderColor = 'transparent';
                  e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.1)';
                }}
              >
                <div style={{ marginBottom: '16px' }}>
                  <h3 style={{ 
                    fontSize: '20px', 
                    marginBottom: '8px',
                    color: 'var(--navy-blue)',
                    fontFamily: 'Comfortaa, cursive'
                  }}>
                    {firm.title}
                  </h3>
                  <div style={ratingStyle}>
                    <span style={{ color: '#fbbf24' }}>⭐</span>
                    <span style={{ fontWeight: '600', color: 'var(--navy-blue)' }}>
                      {firm.puan}
                    </span>
                    <span style={{ color: 'var(--gray-600)', fontSize: '14px' }}>
                      ({firm.yorumlar?.length || 0} yorum)
                    </span>
                  </div>
                </div>

                <p style={{ 
                  color: 'var(--gray-600)', 
                  marginBottom: '16px',
                  fontSize: '14px',
                  lineHeight: '1.5'
                }}>
                  {firm.services}
                </p>

                <div style={{ marginBottom: '16px' }}>
                  <div style={{ fontSize: '14px', color: 'var(--gray-600)', marginBottom: '4px' }}>
                    📍 {firm.acikAdres}
                  </div>
                  <div style={{ fontSize: '14px', color: 'var(--gray-600)', marginBottom: '4px' }}>
                    📞 {firm.kamuTelefon}
                  </div>
                  {firm.kamuEmail && (
                    <div style={{ fontSize: '14px', color: 'var(--gray-600)' }}>
                      📧 {firm.kamuEmail}
                    </div>
                  )}
                </div>

                <div style={{ marginBottom: '20px' }}>
                  <span style={tagStyle}>{firm.sehir}</span>
                  <span style={tagStyle}>{firm.mahalle}</span>
                </div>

                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                  <Link 
                    to={`/firma/${firm.id}`}
                    className="btn btn-primary"
                    style={{ flex: '1', minWidth: '120px', textAlign: 'center' }}
                  >
                    Detaylar
                  </Link>
                  <a 
                    href={`tel:${firm.kamuTelefon}`}
                    className="btn btn-secondary"
                    style={{ flex: '1', minWidth: '120px', textAlign: 'center' }}
                  >
                    Ara
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}


      </div>
    </div>
  );
};

export default CategoryPage;